import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Steps, Button, message, Form, Card } from "antd";
import { useHistory } from "react-router-dom";

import StepFrom from "./step/step-from";
import StepTo from "./step/step-to";
import StepItem from "./step/step-item";
import StepFinal from "./step/step-final";
import Title from "antd/es/typography/Title";

const { Step } = Steps;

const CreateShipment = () => {
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const history = useHistory();
  const [formData, setFormData] = useState({
    sender: {},
    receiver: {},
    item: {},
    charges: [],
  });

  const steps = [
    {
      title: "Sender Details",
      content: (
        <StepFrom form={form} formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: "Recipient Details",
      content: (
        <StepTo form={form} formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: "Item Details",
      content: (
        <StepItem form={form} formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: "Payment Details",
      content: <StepFinal form={form} formData={formData} />,
    },
  ];

  // Fungsi untuk menyimpan data form saat klik "Next"
  const saveStepData = async () => {
    try {
      const values = await form.validateFields();
      setFormData((prevData) => ({ ...prevData, ...values })); // Gabungkan data baru dengan data lama
      return true;
    } catch (error) {
      message.error("Please complete the required fields!");
      return false;
    }
  };

  const next = async () => {
    const isSaved = await saveStepData();
    if (isSaved) {
      setCurrent((prev) => prev + 1);
    }
  };

  const prev = () => {
    setCurrent((prev) => prev - 1);
  };

  const saveShipmentData = async () => {
    try {
      const payload = {
        idShipmentHeader: 0,
        bookingNumber: "123456789",
        bookingDate: new Date().toISOString(),
        idUser: 1,
        name: formData.sender?.name || "John Doe",
        npwp: formData.sender?.npwp || "000000000000000",
        status: "Draft",
        flagActive: true,
        flagFinal: false,
        invoiceNumber: "INV12345",
        invoiceDate: new Date().toISOString(),
        idPayment: 1,
        payment: formData.payment || "Credit Card",
        idService: 1,
        serviceName: formData.serviceName || "Express",
        flagPayment: false,
        flagCustomer: true,
        senderDetail: [
          {
            idSenderDetail: 0,
            idShipmentHeader: 0,
            idUser: 1,
            senderName: formData.sender?.name || "Sender Example",
            company: formData.sender?.company || "Example Company",
            email: formData.sender?.email || "example@email.com",
            telephone: formData.sender?.phone || "123456789",
            idCountry: 1,
            countryCodeOrigin: formData.sender?.countryCode || "ID",
            countryNameOrigin: formData.sender?.country || "Indonesia",
            postalCode: formData.sender?.postalCode || 12345,
            address: formData.sender?.address || "Jl. Contoh No. 1",
            province: formData.sender?.province || "Jakarta",
            city: formData.sender?.city || "Jakarta Selatan",
          },
        ],
        receiverDetail: [
          {
            idReceiverDetail: 0,
            idShipmentHeader: 0,
            receiverName: formData.receiver?.name || "Receiver Example",
            company: formData.receiver?.company || "Receiver Company",
            email: formData.receiver?.email || "receiver@email.com",
            telephone: formData.receiver?.phone || "987654321",
            idCountry: 1,
            countryCodeDestination: formData.receiver?.countryCode || "US",
            countryNameDestination:
              formData.receiver?.country || "United States",
            postalCode: formData.receiver?.postalCode || 54321,
            address: formData.receiver?.address || "123 Example Street",
            province: formData.receiver?.province || "California",
            city: formData.receiver?.city || "Los Angeles",
          },
        ],
        shipmentDetail: [
          {
            idShipmentDetail: 0,
            idShipmentHeader: 0,
            itemDescription: formData.item?.description || "Important Papers",
            itemValue: formData.item?.value || 100,
            quantity: formData.item?.quantity || 1,
            itemWeight: formData.item?.weight || 5,
            idTypePackage: 1,
            typePackage: formData.item?.packageType || "Box",
            shipmentDetailCost: formData.charges.map((charge, index) => ({
              idShipmentDetailCost: index,
              idShipmentDetail: 0,
              idCurrency: 1,
              currency: "USD",
              idTypeCost: 1,
              typeCost: charge.type,
              cost: charge.amount,
            })),
          },
        ],
      };

      await axios.post(
        "http://ili-express-786567254893.asia-southeast2.run.app/shipment/save-shipment",
        payload
      );
      console.log("Shipment data saved successfully:", payload);
      message.success("Shipment data saved successfully!");
      return true;
    } catch (error) {
      console.error("Failed to save shipment data:", error);
      message.error("Failed to save shipment data.");
      return false;
    }
  };

  const onFinish = async () => {
    const isSaved = await saveStepData();
    if (isSaved) {
      const isShipmentSaved = await saveShipmentData();
      if (isShipmentSaved) {
        history.push("/shipment");
      }
    }
  };

  return (
    <>
      <Title title="Create New Shipment" />
      <div>
        <Row gutter={25}>
          <Col lg={24} sm={24} xs={24}>
            <Card>
              <Steps current={current} style={{ marginBottom: "20px" }}>
                {steps.map((item, index) => (
                  <Step key={index} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content">{steps[current].content}</div>
              <div className="steps-action" style={{ marginTop: "20px" }}>
                {current < steps.length - 1 && (
                  <Button type="primary" onClick={next}>
                    Next
                  </Button>
                )}
                {current === steps.length - 1 && (
                  <Button type="primary" onClick={onFinish}>
                    Finish
                  </Button>
                )}
                {current > 0 && (
                  <Button style={{ marginLeft: "8px" }} onClick={prev}>
                    Previous
                  </Button>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CreateShipment;
